import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const createTestConversation = (payload, callback, errCallback) => {
  return async (dispatch) => {
    dispatch({ type: 'CREATING_TEST_CONVERSATION' });
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user.getIdToken();
      const reqId = uuidv4();
      try {
        const response = await axios.post(
          '/ads/create-test-conversation',
          payload,
          {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.status === 200 || response.status === 201) {
          dispatch({
            type: 'CREATING_TEST_CONVERSATION_DONE',
            payload: response?.data,
          });
          if (typeof callback === 'function') callback(response?.data);
        } else {
          dispatch({
            type: 'CREATING_TEST_CONVERSATION_FAILED',
            payload: response?.data,
          });
          if (typeof errCallback === 'function') errCallback();
        }
      } catch (e) {
        console.log(e);
        dispatch({
          type: 'CREATING_TEST_CONVERSATION_FAILED',
          payload: e?.message,
        });
        if (typeof errCallback === 'function') errCallback();
      }
      unsubscribe();
    });
  };
};

export default createTestConversation;
